import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-comment-button',
  standalone: true,
  imports: [NgIf],
  templateUrl: './comment-button.component.html',
  styleUrls: ['./comment-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CommentButtonComponent {
  @Input() showNotificationDot: boolean = false;
  @Output() buttonClicked = new EventEmitter<void>();
}
